// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import SearchOutlinedSvg from "@ant-design/icons-svg/lib/asn/SearchOutlined";
import AntdIcon from "../components/AntdIcon";
const SearchOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: SearchOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    SearchOutlined.displayName = "SearchOutlined";
}
export default /*#__PURE__*/ React.forwardRef(SearchOutlined);
